import { RouteRecordRaw } from 'vue-router';

import errorsMock from './ErrorsMock/router';

const error: Array<RouteRecordRaw> = [...errorsMock];

export default error;
